module.exports = __webpack_public_path__ + "img/alimentacion.8f3fea0a.png";